import { render, staticRenderFns } from "./ResendActivationLink.vue?vue&type=template&id=fd9e8008"
import script from "./ResendActivationLink.vue?vue&type=script&lang=js"
export * from "./ResendActivationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports